import { IConfig } from '@cian/config/shared';
import { ECadastralFieldsNames, TServerErrors } from '../../../../types/reducers/rosreestrData';
import { IGetRosreestrDataParams, IRosreestrDataMeta } from '../types';

export const mapParameters = (
  parameters: IGetRosreestrDataParams['parameters'],
  errors: TServerErrors,
  config: IConfig,
): IRosreestrDataMeta[] => {
  const hideRosreestrServerError = config.get<boolean>('addForm.HideRosreestrServerError.Enabled');

  return Object.entries(parameters).map(field => {
    const [key, value] = field as [ECadastralFieldsNames, string | undefined];

    const serverError = errors[key];

    return {
      key,
      error: serverError && !hideRosreestrServerError ? { value, message: serverError } : undefined,
      checkedValue: serverError ? undefined : value,
    };
  });
};
